import React, { createContext, useCallback, useState, useContext } from 'react';
import VendorServices from 'services/VendorServices';
import { AlertMessagesContext } from 'react-alert-messages';

export const VendorContext = createContext();

function VendorProvider({ children }) {
  const { postAlertMessage } = useContext(AlertMessagesContext);
  
  const [vendors, setVendors] = useState(null);

  const fetchVendors = useCallback(async () => {
    try {
      const data = await VendorServices.getVendors();
      return data || [];
    } catch (error) {
      postAlertMessage?.({
        text: error.message || 'Failed to fetch vendors',
        type: 'failed',
        timeout: 5000,
      });
      return [];
    }
  }, [postAlertMessage]);

  const getVendors = useCallback(async () => {
    if (vendors) {
      return vendors;
    }
    const _vendors = await fetchVendors();
    setVendors(_vendors);
    return _vendors;
  }, [fetchVendors, vendors]);

  return (
    <VendorContext.Provider
      value={{
        vendors,
        getVendors,
        setVendors
      }}
    >
      {children}
    </VendorContext.Provider>
  );
}

export default VendorProvider;
